import { StaticImage } from "gatsby-plugin-image";
import chunk from "lodash.chunk";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import { buildURLForArticle } from "../../utils/buildURL";
import Link from "../../utils/Link";

export const BubbleBlock = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const Contents = ({ data }) => (
    <div className="col-lg-6">
      <h3 className="display-4 mb-4">{text(data.title, userLanguage)}</h3>
      <p className="mb-5">{text(data.description, userLanguage)}</p>
      <Items items={data.items} />
      <Link
        to={`${buildURLForArticle(data.article)}`}
        className={`btn btn-soft-${data.color} rounded-pill mt-6 mb-0`}
      >
        {t("menu.seeAll")}
      </Link>
    </div>
  );

  const Items = ({ items }) => (
    <div className="row gy-3">
      {chunk(items, 2).map((row) => {
        return (
          <div className="col-xl-6">
            <ul
              className={`icon-list bullet-bg bullet-soft-${data.color} mb-0`}
            >
              {row.map((item, index) => (
                <li className={index % 2 == 0 ? "mt-3" : ""}>
                  <span>
                    <i className="uil uil-check"></i>
                  </span>
                  <span>{text(item, userLanguage)}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );

  const Bubble = ({ top, bottom, left, right, transform, color, fill }) => (
    <div
      className={`shape bg-${fill} ${color} rounded-circle rellax w-17 h-17`}
      data-rellax-speed="1"
      style={{
        top: top,
        bottom: bottom,
        left: left ? left : "",
        right: right ? right : "",
        transform: transform,
      }}
    ></div>
  );

  const Figure = ({ url }) => (
    <figure className="rounded mb-0">
      <img src={url} alt="" />
    </figure>
  );

  const align = data.alignment == "LEFT" ? "order-lg-2" : "";

  return (
    <div className="py-10 py-md-12">
      <div className="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
        <div className={`col-lg-6 ${align} position-relative`}>
          {data.alignment == "LEFT" ? <></> : <></>}
          {data.video_url ? (
            <div className="video-wrapper">
              <video
                controls
                autoPlay
                loop
                muted
                width={644}
                height="auto"
                id="vid"
              >
                <source src={data.video_url} type="video/mp4" />
              </video>
            </div>
          ) : (
            <Figure
              url={`https://admin.magjistratura.edu.al${data.image.url}`}
            ></Figure>
          )}
        </div>
        <Contents data={data} />
      </div>
      <br />
    </div>
  );
};

export default BubbleBlock;
